import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { TagIcon } from "components/Elements/Icons"
import { t } from "i18next"

const HeaderBikeLabelOrder: React.FC = () => {
	return (
		<div
			className={clsx("c-section-title mb-7 flex", {
				"px-8": !isMobileOnly,
				"px-6": isMobileOnly,
			})}
		>
			<div
				className={clsx("c-section-title__content justify-between", {
					"items-start": isMobileOnly,
				})}
			>
				<div className="flex items-center justify-start flex-1">
					<TagIcon size={24} />
					<h1 className="c-section-title__title c-h2 text-primary ml-4">
						{t("menu.order_tags")}
					</h1>
				</div>
			</div>
		</div>
	)
}

export default HeaderBikeLabelOrder
